import {
    shallowEqual,
    type TypedUseSelectorHook,
    useDispatch,
    useSelector,
} from "react-redux";
import { type AnyAction } from "redux";
import { type ThunkDispatch } from "redux-thunk";
import { type RootState } from "../Reducers/ShopfrontReducers";
import { type store } from "./RoutingAndStore";

export type ShopfrontDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export const useShopfrontDispatch: () => ShopfrontDispatch = useDispatch<typeof store.dispatch>;
export const useShopfrontSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useShallowShopfrontSelector = <TSelected>(selector: (state: RootState) => TSelected): TSelected => {
    return useSelector(selector, shallowEqual);
};
